import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { FieldLabels } from '@shared/types/enums/fieldLabels.enum';
import { Button } from '@shared/ui/Button';
import { Input } from '@shared/ui/Input';

import {
  changePhone,
  changePrevStep,
  changeStep,
  getVerifyCodeForLoginByPhoneNumber
} from '../../../model/slice/authSlice';
import { Agreement } from '../Agreement/Agreement';
import { Wrap } from '../Wrap/Wrap';
import cls from './Login.module.scss';

export const Login = () => {
  const dispatch = useAppDispatch();
  const phone = useAppSelector((state) => state.auth.phone);
  const isLoading = useAppSelector((state) => state.auth.isLoading);
  const phoneError = useAppSelector((state) => state.auth.phoneError);
  const codeSendingTime = useAppSelector((state) => state.auth.verifyCode.codeSendingTime);
  const errorText = useAppSelector((state) => state.auth.errorText);

  const changePhoneHandler = useCallback(
    (value: string) => {
      dispatch(changePhone({ value, key: 'login' }));
    },
    [dispatch]
  );

  const clickNextHandler = () => {
    const currentTime = new Date().getTime();

    if (+codeSendingTime > currentTime) {
      dispatch(changeStep('verify'));
      dispatch(changePrevStep('login'));
    } else {
      dispatch(changePrevStep('login'));
      dispatch(getVerifyCodeForLoginByPhoneNumber());
    }
  };

  return (
    <Wrap title={'Войти в учетную запись'}>
      <div
        data-testid={'login'}
        className={cls.wrap}
      >
        <Input
          autoFocus
          testId={'login-phone-input'}
          className={cls.input}
          value={phone}
          onChange={changePhoneHandler}
          label={FieldLabels.PHONE_NUMBER}
          isError={!!phoneError || !!errorText}
          errorText={phoneError || errorText}
          phoneMask
        />
        <Button
          size={'l'}
          testId={'login-send-button'}
          loadingButton
          isLoading={isLoading}
          onClick={clickNextHandler}
          className={cls.button}
        >
          Продолжить
        </Button>
        <Agreement />
      </div>
    </Wrap>
  );
};
